import { render, staticRenderFns } from "./alarm-handling.vue?vue&type=template&id=345036fc&scoped=true"
import script from "./alarm-handling.vue?vue&type=script&lang=js"
export * from "./alarm-handling.vue?vue&type=script&lang=js"
import style0 from "./alarm-handling.vue?vue&type=style&index=0&id=345036fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345036fc",
  null
  
)

export default component.exports